import styled from 'styled-components';
import AppVersion from 'components/common/AppVersion';
import Logo from '../../../assets/img/logo.svg';
import AccessibilitySection from './AccessibilitySection';

const GENEVA_URL = 'https://www.genevatrust.pl/';

const StyledContainer = styled.div`
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    padding-bottom: 16px;

    @media screen and (max-width: 768px) {
        padding: 16px;
    }
`;

const StyledWrapper = styled.div`
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;
    position: relative;
    gap: 8xp;

    @media screen and (max-width: 1500px) {
        justify-content: space-between;
    }

    @media screen and (max-width: 1000px) {
        flex-direction: column;
    }
`;

const StyledLink = styled.a`
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
`;

const StyledLogo = styled.img`
    width: 353px;
    height: 58px;

    @media screen and (max-width: 800px) {
        width: 250px;
        height: 40px;
    }
`;

const Header = () => (
    <StyledContainer>
        <StyledWrapper>
            <AccessibilitySection />
            <StyledLink href={GENEVA_URL} target="_blank">
                <StyledLogo src={Logo} alt="logo" />
            </StyledLink>
        </StyledWrapper>
        {process.env?.NODE_ENV !== 'production' && <AppVersion />}
    </StyledContainer>
);

export default Header;
